module.exports = __webpack_public_path__ + "h5-static/img/loading.a603612b.gif";